import { useEffect, useState } from "react";
import { Check, Loader2, Send, X } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg, money } from "@/lib/api";

const Item = ({ e, busy, onOk, onNon }) => (
  <li className="flex flex-wrap items-center justify-between gap-2 py-2 text-xs" data-testid={`envoi-attente-${e.id}`}>
    <span><span className="font-medium">{e.locataire}</span> · {e.courriel} · rappel courtois · loyer de {e.mois} · {money(e.montant)}</span>
    <span className="flex gap-1.5">
      <Button size="sm" className="h-7 px-2 text-[11px] bg-emerald-700 hover:bg-emerald-800" disabled={busy} onClick={() => onOk(e)} data-testid={`envoi-attente-autoriser-${e.id}`}><Check className="h-3 w-3 mr-1" />Autoriser</Button>
      <Button size="sm" variant="outline" className="h-7 px-2 text-[11px]" disabled={busy} onClick={() => onNon(e)} data-testid={`envoi-attente-annuler-${e.id}`}><X className="h-3 w-3 mr-1" />Annuler</Button>
    </span>
  </li>
);

export const EnvoisAttente = ({ version, onDone }) => {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/envois-attente").then((r) => setRows(r.data)).catch((err) => toast.error(errMsg(err)));
  useEffect(() => { load(); }, [version]);
  const agir = async (liste, action) => {
    setBusy(true);
    let ok = 0;
    for (const e of liste) {
      try { await (action === "ok" ? api.post(`/envois-attente/${e.id}/autoriser`) : api.delete(`/envois-attente/${e.id}`)); ok += 1; }
      catch (err) { toast.error(`${e.locataire} : ${errMsg(err)}`); }
    }
    if (ok) toast.success(action === "ok" ? `${ok} rappel(s) envoyé(s)` : `${ok} envoi(s) annulé(s)`);
    setBusy(false); load(); onDone();
  };
  if (!rows.length) return null;
  return (
    <div className="mt-4 rounded-md border border-amber-200 bg-amber-50/60 p-3" data-testid="envois-attente">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-xs font-medium text-amber-900"><Send className="inline h-3.5 w-3.5 mr-1" />Rappels préparés le 7, en attente de votre autorisation ({rows.length})</p>
        <Button size="sm" className="h-7 px-2 text-[11px] bg-emerald-700 hover:bg-emerald-800" disabled={busy} onClick={() => agir(rows, "ok")} data-testid="envois-attente-tout-autoriser">
          {busy && <Loader2 className="h-3 w-3 mr-1 animate-spin" />}Tout autoriser
        </Button>
      </div>
      <ul className="mt-2 divide-y divide-amber-100">{rows.map((e) => <Item key={e.id} e={e} busy={busy} onOk={(x) => agir([x], "ok")} onNon={(x) => agir([x], "non")} />)}</ul>
    </div>
  );
};
